import React from 'react'
import { injectStripe } from 'react-stripe-elements'
import { TOKEN_STORAGE_KEY, getStorage, USER_STORAGE_KEY } from "../../dataHelpers/authenticationHelpers"
import { SUBS_HELPER_CONSTLIST } from '../../constants'
import { subscriptionHelpers } from '../../dataHelpers';
import AppError from "../../models/AppError";
import { ErrorModal, PaymentSuccessModal, LoadingModal } from './../ui'
import AchForm from './AchForm'
let date = new Date();

class AchPaymentForm extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            loading: false,
            modal: false,
            paymentModal: false,
            backdrop: 'static',
            errors: [],
            paymentID: null,
            transDetails: null,
            paymentAmount: 0,
            randomPaymentId: null,
            accountType: '',
            amount: 0,
        }
        this.token = (props.token || JSON.parse(getStorage().getItem(TOKEN_STORAGE_KEY)))
        this.user = (props.token || JSON.parse(getStorage().getItem(USER_STORAGE_KEY)))
        this.toggle = this.toggle.bind(this);
        this.renewPlan = this.renewPlan.bind(this);
        this.renewSubscriptionPlan = props.renewSubscriptionPlan
        this.invoicePayment = props.invoicePayment
    }

    toggle() {
        this.setState({
            modal: !this.state.modal,
            paymentModal: false
        });
    }

    dismissError(error) {
        let errors = this.state.errors.filter((e) => e !== error)
        this.setState({ errors, modal: true, loading: false })
    }

    async renewPlan() {
        this.setState({ paymentModal: false })
        try {
            this.savePaymentDetails(this.state.paymentID, this.state.transDetails, this.state.randomPaymentId)
        } catch (error) {
            console.log(error.message)
        }
    }

    async savePaymentDetails(paymentID, transDetails, randomPaymentId) {
        try {
            let paidBy = this.user.email
            let controllerId = this.props.controllerid
            let savePaymentResponse = await subscriptionHelpers.savePayment(this.token, paymentID, transDetails, randomPaymentId, paidBy, controllerId)
            if (!savePaymentResponse.error) {
                this.renewSubscriptionPlan()
                //return
            } else {
                this.setState({ errors: [savePaymentResponse.error] })
            }
        } catch (error) {
            console.log(error.message)
        }
    }

    handleSubmit = (ev) => {
        ev.preventDefault();
        this.setState({ loading: true })
        let descVal = ev.target.description.value
        if (this.props.stripe) {
            this.props.stripe
                .createToken('bank_account', {
                    country: 'US',
                    currency: 'usd',
                    routing_number: ev.target.routing_number.value,
                    account_number: ev.target.account_number.value,
                    account_holder_name: ev.target.account_holder_name.value,
                    account_holder_type: ev.target.account_type.value,
                }).then((result) => {
                    if (!result.error) {
                        this.createAchCustomer(result.token.id, descVal)
                    } else {
                        console.log(result.error);
                        let appError = new AppError(SUBS_HELPER_CONSTLIST.INVALID_REQUEST, result.error.message)
                        this.setState({ errors: [appError], loading: false })
                    }
                })
        } else {
            console.log(SUBS_HELPER_CONSTLIST.STRIPE_NOT_LOAD);
        }
    };

    async createAchCustomer(sourceId, descVal) {
        try {
            let customerResponse = await subscriptionHelpers.achCustomer(this.token, sourceId, descVal)
            if (!customerResponse.error) {
                this.verifyAchCustomer(customerResponse.id.sources.data[0].customer, customerResponse.id.sources.data[0].id)
            } else {
                this.setState({ errors: [customerResponse.error], loading: false })
            }
        } catch (error) {
            let appError = new AppError(SUBS_HELPER_CONSTLIST.PAYMENT_FAIL, error.message)
            this.setState({ errors: [appError], loading: false })
        }
    }

    async verifyAchCustomer(custId, sourceId) {
        try {
            let verifyResponse = await subscriptionHelpers.verifyAch(this.token, custId, sourceId)
            if (!verifyResponse.error) {
                let verifyStatus = verifyResponse.verify.status
                if (verifyStatus == 'verified') {
                    this.createAchCharge(verifyResponse.verify.customer)
                } else {
                    let appError = new AppError(SUBS_HELPER_CONSTLIST.PAYMENT_FAIL, SUBS_HELPER_CONSTLIST.ACCOUNT_NOT_VERIFY)
                    this.setState({ errors: [appError], loading: false })
                }
            } else {
                this.setState({ errors: [verifyResponse.error], loading: false })
            }
        } catch (error) {
            let appError = new AppError(SUBS_HELPER_CONSTLIST.PAYMENT_FAIL, error.message)
            this.setState({ errors: [appError], loading: false })
        }
    }

    async createAchCharge(customerId) {
        try {
            let amount = this.props.amount * 100
            let chargeResponse = await subscriptionHelpers.achCharge(this.token, customerId, amount)
            if (!chargeResponse.error) {
                if (this.props.invoicePayment) {
                    this.invoicePayment()
                }
                this.setState({
                    loading: false,
                    modal: false,
                    paymentModal: true,
                    backdrop: 'static',
                    paymentID: chargeResponse.id.id,
                    transDetails: JSON.stringify(chargeResponse.id),
                    paymentAmount: chargeResponse.id.amount,
                    randomPaymentId: Math.floor(1000000000 + Math.random() * 9000000000) //create 10 digit random numbers
                })
            } else {
                this.setState({ errors: [chargeResponse.error], loading: false })
            }
        } catch (error) {
            let appError = new AppError(SUBS_HELPER_CONSTLIST.PAYMENT_FAIL, error.message)
            this.setState({ errors: [appError], loading: false })
        }
    }

    render() {
        let { errors, loading, paymentID, randomPaymentId, paymentAmount } = this.state
        let day = (date.getDate() < 10 ? '0' + date.getDate() : date.getDate())
        let month = ((date.getMonth() + 1) < 10 ? '0' + (date.getMonth() + 1) : (date.getMonth() + 1))
        let currDate = month + '-' + day + '-' + date.getFullYear()
        return (
            <div>
                {(errors.map((appError, idx) =>
                    <ErrorModal key={idx} modal={true} toggle={() => (this.dismissError(appError))} text={appError.text} title={appError.title} />
                ))}            
                <LoadingModal modal={loading}/> 
                <div>
                    <AchForm onSubmit={this.handleSubmit} amount={this.props.amount} />
                    <PaymentSuccessModal isOpen={this.state.paymentModal} toggle={this.toggle} backdrop={this.state.backdrop} renewSubPlan={this.renewPlan}
                        randomPaymentId={randomPaymentId} paymentID={paymentID} paymentAmount={paymentAmount} paidBy={this.user.email} currDate={currDate} />
                </div>                
            </div>
        );
    }
}
export default injectStripe(AchPaymentForm);


// WEBPACK FOOTER //
// ./src/components/ui/AchPaymentForm.js